<div class="header-wrapper">
  <nav class="navbar">
    <div class="navbar-brand">
      <a
        class="navbar-burger"
        (click)="toggleSideMenu()"
        role="button"
        aria-label="menu"
        aria-expanded="false"
      >
        <i class="fa fa-bars" aria-hidden="true"></i>
      </a>
    </div>
    @if (currentUser) {
    <div class="navbar-start">
      <div class="company-detail">
        <a class="nav-item">
          @if (!currentUser.company_logo) {
          <img [src]="'../../assets/images/gpt-logo.png'" alt="AbsenceGPT" />
          } @if (currentUser.company_logo) {
          <img
            [src]="companyUrl + currentUser.company_logo"
            alt="AbsenceGPT"
            style="width: 45px"
          />
          }
        </a>
        <div class="company-name">
          @if (!currentUser.title) {
          <strong class="is-size-5 has-text-white">Absence GPT</strong>
          } @if (currentUser.title) {
          <strong class="is-size-5 has-text-white">{{
            currentUser.title
          }}</strong>
          } @if (!currentUser.caption) {
          <span
            class="subtitle is-size-7 has-text-white"
            style="padding: 1px 0px"
          >
            Learn Anytime Anywhere
          </span>
          } @if (currentUser.caption) {
          <span
            class="subtitle is-size-7 has-text-white"
            style="padding: 1px 0px"
          >
            {{ currentUser.caption }}
          </span>
          }
        </div>
        <!-- <p
              class="subtitle is-size-7 has-text-white"
              style="padding: 1px 13px"
              *ngIf="isUserRole == 1"
              >
              Teach Anytime Anywhere
            </p> -->
      </div>
    </div>
    }
    <div class="nav-center">
      <!-- <div class="cs-header-search-bar cs-global-search" *ngIf="currentUser">
        <app-search style="width: 100%;"></app-search>
      </div> -->
    </div>
    <div class="navbar-end">
      <!-- <div class="channel-actions" *ngIf="isUserLoggedIn == true">
      <div>
        <h2>Subject </h2>
        <ng-select (change)="switchCompanyId($event)" [searchable]="false" [multiple]="false" class="company_list" placeholder="Switch company here....." [clearable]="false" [(ngModel)]="singleSelect">
          <ng-option *ngFor="let c of activeUserChannelList" [value]="c.id" selected>{{c.company_name}}</ng-option>
        </ng-select>
      </div>
    </div> -->
      <div class="navbar-item has-dropdown is-hoverable" style="display: none">
        @if (currentUser) {
        <a class="navbar-link">
          @if (!currentUser.user_icon) {
          <div class="empty-head-icon" title="{{ authStatus.title }}">
            {{ displayUserFirstLetter(currentUser.first_name) }}
          </div>
          } @if (currentUser.user_icon) {
          <img
            [src]="profileUrl + currentUser.user_icon"
            alt="{{ authStatus.title }}"
            title="{{ authStatus.title }}"
          />
          }
          <span class="icon is-small">
            <i
              class="fa fa-circle"
              [ngClass]="{
                'circle-grey': currentUser.user_status === 0,
                'circle-green': currentUser.user_status === 1,
                'circle-red': currentUser.user_status === 2,
                'circle-yellow': currentUser.user_status === 3
              }"
            ></i>
          </span>
        </a>
        }

        <div class="navbar-dropdown is-right">
          <!-- <a class="navbar-item">
        Give Feedback
      </a> -->
          <a class="nested navbar-item dropdown">
            @if (currentUser) {
            <a
              class="dropdown-trigger"
              aria-haspopup="true"
              aria-controls="dropdown-menu"
            >
              <i
                class="fa fa-circle"
                [ngClass]="{
                  'circle-grey': currentUser.user_status === 0,
                  'circle-green': currentUser.user_status === 1,
                  'circle-red': currentUser.user_status === 2,
                  'circle-yellow': currentUser.user_status === 3
                }"
              ></i>
              {{ currentUser.status_name }}
            </a>
            }

            <div class="dropdown-menu" id="dropdown-menu" role="menu">
              <div class="dropdown-content">
                <p class="has-text-grey">Default Status</p>
                @for (data of statusDetails; track data) {
                <p>
                  <a
                    class="dropdown-item"
                    (click)="onSelectOption(data)"
                    title="{{ data.sm_name }}"
                  >
                    <i
                      class="fa fa-circle"
                      [ngClass]="{
                        'circle-grey': data.sm_id === 0,
                        'circle-green': data.sm_id === 1,
                        'circle-red': data.sm_id === 2,
                        'circle-yellow': data.sm_id === 3
                      }"
                    ></i>
                    {{ data.sm_name }}
                  </a>
                  <!-- <a class="dropdown-item" (click)="onSelectOption('away')" title="Away">
                <i class="fa fa-circle circle-yellow"></i> Away
              </a>
              <a class="dropdown-item" (click)="onSelectOption('busy')" title="Busy">
                <i class="fa fa-circle circle-red"></i> Busy
              </a>
              <a class="dropdown-item" (click)="onSelectOption('out of office')" title="Out of Office">
                <i class="fa fa-circle circle-gray"></i> Out of Office
              </a> -->
                </p>
                }
                <!-- <hr class="dropdown-divider">
          <p class="has-text-grey">Custom Status</p>
          <a class="dropdown-item" (click)="onSelectOption(['Be right back', 'circle-green'])">
            <i class="fa fa-circle circle-green"></i>

            <input type="text" class="input is-small" (keyup)="changeCustomStatus($event)" maxlength="15" value="Be Right Way">
          </a>
          <a class="dropdown-item" (click)="onSelectOption(['Off Work', 'circle-yellow'])">
            <i class="fa fa-circle circle-yellow"></i> <input type="text" class="input is-small" (keyup)="changeCustomStatus($event)" maxlength="15" value="Off Way" >
          </a>
          <a class="dropdown-item" (click)="onSelectOption(['Do not disturb', 'minus-circle'])">
            <i class="fa minus-circle"></i> <input type="text" class="input is-small" (keyup)="changeCustomStatus($event)" maxlength="15" value="Do not Distrub">
          </a> -->
              </div>
            </div>
          </a>
          <a class="navbar-item" routerLink="/settings">
            <i class="fa fa-cog"></i>Settings
          </a>
          <!-- <a class="navbar-item" routerLink="/subscription">
    <i class="fa fa-money"></i>My Subscription
  </a> -->
          <!-- <a class="navbar-item" routerLink="/help">
  <i class="fa fa-question-circle"></i>Help
</a> -->
          <hr class="navbar-divider" />
          <a class="navbar-item" (click)="logout()">
            <i class="fa fa-sign-out"></i> Log out
          </a>
        </div>
      </div>
    </div>
  </nav>
  <!-- <div class="success-alert"></div> -->
  @if (connectionMonitor == false) {
  <div class="message is-warning has-text-centered is-small connectionMonitor">
    <div class="message-body">
      <p>
        <i class="fa fa-exclamation-triangle"></i> Not Connected to Internet
        <span>{{ timer }} </span> <a (click)="onlineCheck()">Try now</a>
      </p>
      <!-- <button class="delete" aria-label="delete"></button> -->
    </div>
  </div>
  }
</div>
